module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_yamaguchi-e93632690d674b53970dcb3dd0595fac.png";